export const selectorChangeAccordionProduct = (state) => state.changeAccordionProduct;
